<template>
  <div class="indexPage">
    <div class="list">
      <div class="item" v-if="dataItem != ''">
        <div class="block_one">
          <div class="column flex-rowl">
            <p class="label">创建时间：</p>
            <p class="con">{{ dataItem.order_time }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单状态：</p>
            <p class="con">
              {{
                dataItem.service_order_status == 1
                  ? "待接单"
                  : dataItem.service_order_status == 2
                  ? "已接单"
                  : dataItem.service_order_status == 3
                  ? "取餐中"
                  : dataItem.service_order_status == 4
                  ? "送餐中"
                  : dataItem.service_order_status == 5
                  ? "待自提"
                  : dataItem.service_order_status == 6
                  ? "已送达"
                  : "已完成"
              }}
            </p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单情况：</p>
            <p class="con">
              {{
                dataItem.service_order_property == 1
                  ? "服务订单进行中"
                  : dataItem.service_order_property == 2
                  ? "服务订单取消申请中"
                  : dataItem.service_order_property == 3
                  ? "服务订单已取消"
                  : "服务订单已完成"
              }}
            </p>
          </div>
        </div>

        <div class="block_two">
          <div class="column flex-rowl">
            <p class="label">服务订单号：</p>
            <p class="con">{{ dataItem.service_order_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单号：</p>
            <p class="con">{{ dataItem.order_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">餐厅名称：</p>
            <p class="con">{{ dataItem.shop_name }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">送餐位置：</p>
            <p class="con">{{ dataItem.address_detail }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">送餐楼栋：</p>
            <p class="con">{{ dataItem.buildingidstr }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">关联取餐柜：</p>
            <p class="con">{{ dataItem.service_rating }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">用户姓名：</p>
            <p class="con">{{ dataItem.truename }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">联系电话：</p>
            <p class="con">{{ dataItem.customer_phone }}</p>
          </div>
          <div class="column">
            <p class="label">订单内容：</p>
            <div class="column-list">
              <div
                class="column-item flex-between"
                v-for="(item, index) in orderContent"
                :key="index"
              >
                <p class="txt">{{ item.ordercont }}</p>
                <p
                  class="state flex-rowc"
                  :class="{ disabled: item.getstate == 1 }"
                  @click="singleTakeMeal(item, index)"
                >
                  {{ item.getstate == 1 ? "已取餐" : "确认取餐" }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="block_three" v-if="dataItem.service_order_status >= 3">
          <div class="column flex-rowl">
            <p class="label">取餐员：</p>
            <p class="con">{{ pickupInfo.pickup_staff_name }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">取餐员工号：</p>
            <p class="con">{{ pickupInfo.pickup_staff_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">联系方式：</p>
            <p class="con">{{ pickupInfo.pickup_staff_contact }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">取餐时间：</p>
            <p class="con">{{ pickupInfo.pickup_time }}</p>
          </div>
        </div>

        <div class="btn flex-colc">
          <template v-if="dataItem.service_order_status == 2">
            <div class="flex-rowr btn_group">
              <div class="primary-button flex-rowl" @click="handleAllTakeMeal">
                <i class="iconfont icon-yuanquangouxuan"></i> 全部确认取餐
              </div>
              <div
                class="primary-button-plain flex-rowl stop_btn"
                @click="handleRefuse"
              >
                <i class="iconfont icon-paizhao"></i> 订单出现问题
                <!-- <i class="iconfont icon-paizhao"></i> 暂停取餐 -->
              </div>
            </div>
            <div
              class="primary-button-plain flex-rowl query_btn"
              @click="handleQuery(true)"
            >
              <i class="iconfont icon-paizhao"></i>确认取餐并继续扫码
            </div>
          </template>
          <template v-else-if="dataItem.service_order_status > 2">
            <div class="default-button">已全部取餐</div>
          </template>
        </div>
      </div>

      <van-empty
        description="该订单不存在"
        v-if="!isLoading && dataItem == ''"
      />
    </div>

    <div class="custom_btn" @click="handleReturn">返回</div>
  </div>
</template>
  
<script>
import {
  getOrderInfo,
  getToken,
  getOrderDetail,
  getOrderTakeMeal,
} from "../../api/api";
export default {
  name: "tMealIndex",
  data() {
    return {
      isLoading: true,
      userInfo: "", // 用户信息
      dataItem: "", // 订单信息
      pickupInfo: "", // 取餐信息
      order_id: "", // 订单id
      token: "", // token
      orderContent: "", // 订单内容

      isContinueScane: false,
      isOrder: false,
    };
  },
  created() {
    let { id, isOrder } = this.$route.params;
    this.order_id = id;
    this.isOrder = isOrder ? isOrder : false;
    this.token = this.$store.state.Authorization;
    this.userInfo = this.$store.state.USERINFO;
    this.getOrderInfo();
  },
  methods: {
    // 刷新 token 的方法
    async refreshToken() {
      try {
        const res = await getToken();
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          this.token = res.data.token;
        } else {
          throw new Error(res.message || "获取 token 失败");
        }
      } catch (error) {
        this.$toast.fail(error.message || "获取 token 失败，请稍后重试");
        throw error;
      }
    },

    // 查看订单详情
    async getOrderInfo() {
      try {
        this.$toast.loading({
          message: "加载中...",
          forbidClick: true,
        });
        let params = {
          order_id: this.order_id,
          token: this.token,
        };
        let res = await getOrderInfo(params);
        if (res.error_code == 1) {
          await this.refreshToken();
          params.token = this.token;
          res = await getOrderInfo(params);
        }
        if (res.error_code == 0) {
          if (Object.values(res.data).length != 0) {
            this.dataItem = res.data;
            this.pickupInfo = res.data.pickup;
            this.deliveryInfo = res.data.delivery;
            this.serinfoInfo =
              Object.values(res.data.serinfo).length != 0
                ? res.data.serinfo
                : "";

            await new Promise((resolve) => setTimeout(resolve, 200));
            this.getOrderDetail(this.dataItem.order_id);
          } else {
            this.dataItem = "";
            this.pickupInfo = "";
            this.deliveryInfo = "";
            this.serinfoInfo = "";
            this.$toast.fail("暂无详情数据");
          }
        } else {
          throw new Error(res.message || "获取订单详情失败");
        }
      } catch (error) {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.$toast.fail(error.message || "接口失效，请稍后～");
      }
    },

    // 获取订单商品明细
    async getOrderDetail(order_id) {
      try {
        const res = await getOrderDetail({
          token: this.token,
          order_id,
        });
        if (!res.result) {
          throw new Error(res.message || "获取订单商品明细失败");
        }
        this.orderContent = res.list;
        this.isShow = true;
        this.$toast.clear();
      } catch (error) {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.$toast.fail(error.message || "接口失效，请稍后～");
      }
    },

    handleQuery(isTrue) {
      let { dataItem } = this;
      if (dataItem.service_order_status == "待接单") return;
      this.isContinueScane = isTrue;
      this.getToken(true);
    },

    // 调用商品取餐接口
    async getOrderTakeMeal(item, index) {
      try {
        let { userInfo } = this;
        let params = {
          order_id: item.order_id,
          token: this.token,
          pickup_staff_id: userInfo.accountid,
          id: item.id,
        };
        let res = await getOrderTakeMeal(params);
        if (res.error_code == 1) {
          await this.refreshToken();
          params.token = this.token;
          res = await getOrderTakeMeal(params);
        }
        if (res.error_code == 0) {
          // 修改该条商品的取餐状态
          this.$set(this.orderContent, index, { ...item, getstate: 1 });
        } else {
          throw new Error(res.message || "取餐失败");
        }
      } catch (error) {
        this.$toast.fail(error.message || "接口失效，请稍后～");
      }
    },

    /**
     * 单个商品取餐
     * @param {Object} item - 商品对象
     * @param {number} index - 商品在数组中的索引
     */
    async singleTakeMeal(item, index) {
      console.log(item, "=====w");

      try {
        // 判断是否取餐
        if (item.getstate == 1) return;
        this.$toast.loading({
          message: "取餐中...",
          forbidClick: true,
          duration: 0,
        });
        await this.getOrderTakeMeal(item, index);
        await new Promise((resolve) => setTimeout(resolve, 500));
        // 清除加载提示
        this.$toast.clear();
        // 检查是否所有商品都已取餐
        const allTaken = this.orderContent.every((item) => item.getstate == 1);
        if (allTaken) {
          this.handleState();
        }
      } catch (error) {
         await new Promise((resolve) => setTimeout(resolve, 200));
        this.$toast.fail(error.message || "接口失效，请稍后～");
      }
    },

    /**
     * 全部商品取餐
     */
    async handleAllTakeMeal() {
      const pendingItems = this.orderContent.filter(
        (item) => item.getstate == 0
      );
      if (pendingItems.length == 0) {
        return;
      }
      this.$toast.loading({
        message: "全部取餐中...",
        forbidClick: true,
        duration: 0,
      });
      try {
        for (let i = 0; i < pendingItems.length; i++) {
          const item = pendingItems[i];
          const index = this.orderContent.indexOf(item);
          await this.getOrderTakeMeal(item, index);
        }
        await new Promise((resolve) => setTimeout(resolve, 200));
        this.$toast.clear();
        this.handleState();
      } catch (error) {
        this.$toast.fail("部分商品取餐失败，请重试");
      }
    },

    handleState() {
      let { isContinueScane, isOrder } = this;
      if (isOrder) {
        // 继续扫码
        if (isContinueScane) {
          this.$router.push(`/qrcode/2`);
        } else {
          // 返回首页
          this.$router.back();
        }
      } else {
        // 继续扫码
        if (isContinueScane) {
          this.$router.back();
        } else {
          // 返回首页
          this.$router.go(-2);
        }
      }
      this.getOrderInfo();
    },

    // 拒绝取餐
    handleRefuse() {
      this.$toast("即将开放");
      // this.$router.push(`/tekeMeal/tMealRefuse/${this.order_id}`)
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.indexPage {
  padding-top: 40px;
  padding-bottom: 280px;
  .list {
    .item {
      width: 660px;
      min-height: 700px;
      background: #ffffff;
      border: 6px solid #e6e6e6;
      border-radius: 40px;
      margin: 0 auto 30px;
      padding: 52px 44px 0;
      box-sizing: border-box;
      font-size: 28px;
      color: #040000;
      .block_one {
        font-size: 22px;
        margin-bottom: 65px;
        .column {
          .label {
            width: 140px;
          }
        }
      }
      .block_two {
        margin-bottom: 99px;
      }
      .block_three {
        margin-bottom: 85px;
      }
      .btn {
        margin-bottom: 60px;
        align-items: flex-end;
        .btn_group {
          margin-bottom: 30px;
        }
        .primary-button {
          width: 270px;
          position: relative;
        }
        .primary-button-plain {
          width: 260px;
          margin-left: 20px;
          position: relative;
          &.stop_btn {
            width: 270px;
            // margin-bottom: 30px;
          }
          &.query_btn {
            width: 400px;
          }
        }
        .iconfont {
          margin: 0 15px 0 17px;
          // position: absolute;
          // left: 17px;
          &.icon-paizhao {
            font-size: 40px;
          }
          &.icon-yuanquangouxuan {
            font-size: 38px;
          }
        }
      }
      .column {
        align-items: flex-start;
        &:nth-child(2n) {
          margin: 26px 0;
        }
        .label {
          white-space: nowrap;
          width: 190px;
          flex-shrink: 0;
        }
        .con {
          word-wrap: break-word;
          flex-shrink: 0;
          width: 380px;
        }
      }
    }
  }
  .column-list {
    margin: 30px 0 30px;
    .column-item {
      font-size: 24px;
      margin-bottom: 30px;
      &:last-child {
        margin-bottom: 0;
      }
      .txt {
        line-height: 28px;
      }
      .state {
        flex-shrink: 0;
        margin-left: 40px;
        width: 130px;
        height: 40px;
        border-radius: 50px;
        background: #096f70;
        color: #fff;
        font-size: 22px;
        &.disabled {
          background: #9e9e9e;
        }
      }
    }
  }
}
</style>